import { CSSObject } from '@chakra-ui/react';
import bgDesktop from '@/assets/slambet/images/onboarding/onboardingAside.png';
import bgMobile from '@/assets/slambet/images/onboarding/onboardingAsideMb.png';

export const WrapperAside: CSSObject = {
  bg: [
    `url(${bgMobile}), var(--bc-colors-beta-800)`,
    null,
    `url(${bgDesktop}), var(--bc-colors-beta-800)`,
  ],
  bgSize: ['cover', null, '100%, 100%'],
  bgRepeat: ['no-repeat', null, 'no-repeat'],
  display: 'flex',
  flexDir: 'column',
  px: [null, null, '10px'],
  borderBottom: ['3px', null, 'unset'],
  borderBottomColor: ['beta.500', null, 'unset'],
  h: ['50vw', '55vw', 'full'],
  borderLeftRadius: [null, null, '10px'],
  borderRightRadius: ['unset'],
  pt: ['4', null, '6'],
  flex: 1,
};
